import { STORE_URL } from 'constants/externalLinks';
import { localStorage } from 'lib/storage/localStorage';

type Options = {
  invitationToken?: string | null;
  impactId?: string | null;
  referrer?: string | null;
  googleClickId?: string | null;
  facebookClickId?: string | null;
  twitterClickId?: string | null;
  tikTokClickId?: string | null;
  snapchatClickId?: string | null;
  redditClickId?: string | null;
};

const useOneLinkUrl = (
  href: string,
  {
    invitationToken,
    impactId,
    referrer,
    googleClickId,
    facebookClickId,
    twitterClickId,
    tikTokClickId,
    snapchatClickId,
    redditClickId,
  }: Options
) => {
  const url = new URL(href);
  if (invitationToken) {
    url.searchParams.append('deep_link_sub1', invitationToken);
  }
  if (impactId) {
    url.searchParams.append('deep_link_sub2', impactId);
  }
  if (referrer) {
    url.searchParams.append('deep_link_sub3', `referrer:${referrer}`);
  }
  if (googleClickId) {
    url.searchParams.append('deep_link_sub3', `gclid:${googleClickId}`);
  }
  if (facebookClickId) {
    url.searchParams.append('deep_link_sub3', `fbclid:${facebookClickId}`);
  }
  if (twitterClickId) {
    url.searchParams.append('deep_link_sub3', `twclid:${twitterClickId}`);
  }
  if (tikTokClickId) {
    url.searchParams.append('deep_link_sub3', `ttclid:${tikTokClickId}`);
  }
  if (snapchatClickId) {
    url.searchParams.append('deep_link_sub3', `ScCid:${snapchatClickId}`);
  }
  if (redditClickId) {
    url.searchParams.append('deep_link_sub3', `rdt_cid:${redditClickId}`);
  }

  return url.href;
};

export const useStoreUrl = () => {
  const referrer = localStorage.getItem('referrer');
  const impactId = localStorage.getItem('irclickid');
  const googleClickId = localStorage.getItem('gclid');
  const facebookClickId = localStorage.getItem('fbclid');
  const twitterClickId = localStorage.getItem('twclid');
  const tikTokClickId = localStorage.getItem('ttclid');
  const snapchatClickId = localStorage.getItem('ScCid');
  const redditClickId = localStorage.getItem('rdt_cid');
  const invitationToken = localStorage.getItem('invitation_token');

  return useOneLinkUrl(STORE_URL, {
    invitationToken,
    impactId,
    googleClickId,
    facebookClickId,
    twitterClickId,
    tikTokClickId,
    snapchatClickId,
    redditClickId,
    referrer,
  });
};
